@if (rows().length) {
  <div class="timeline__context">
    <span class="timeline__key">
      <span class="timeline__marker timeline__marker--signal" aria-hidden="true"></span>
      Pressure deviation
    </span>
  </div>
  <div class="timeline__chart">
    <canvas
      [data]="chartData()"
      [options]="chartOptions()"
      (chartClick)="onChartClick($event.active)"
      baseChart
      type="bar"
      role="img"
      aria-label="Signal timeline by asset. Select a pressure deviation signal to inspect its evidence.">
    </canvas>
  </div>
} @else {
  <p class="timeline__empty">No valid signal start timestamps are available.</p>
}